import React from 'react';

/** Target on-screen stroke thickness (px). */
const TARGET_STROKE_PX = 1.4;

/** Map target px stroke to SVG user units for a given display size. */
export function editTimelineMatchedStroke(displaySize, strokeWidth) {
  if (strokeWidth != null) return strokeWidth;
  return TARGET_STROKE_PX * (24 / displaySize);
}

/** Split-at-playhead icon for Edit timeline actions. */
export default function EditTimelineIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  style,
  className,
}) {
  const resolvedStroke = editTimelineMatchedStroke(size, strokeWidth);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={resolvedStroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      style={{ display: 'block', flexShrink: 0, ...style }}
      className={className}
    >
      <line x1="12" y1="4" x2="12" y2="20" />
      <path d="M8 5H4v14h4" />
      <path d="M16 5h4v14h-4" />
    </svg>
  );
}
